export default __webpack_public_path__ + "static/media/logo.dfa85b0f.png";